import AutoNavUrl from '@alme/ui-web/ref/auto-nav-url';
import ClientCommunicator from '@alme/ui-web/ref/clientcommunicator';
import HistoryAppender from '@alme/ui-web/ref/history-appender-maskedinput';
import Initialization from '@alme/ui-web/ref/initialize';
import LaunchMessageProcessor from '@alme/ui-web/ref/launch-message-processor';
import MobileDeviceDetector from '@alme/ui-web/ref/mobile-device-detector';
import PersistentStorage from '@alme/ui-web/ref/persistence';
import PersistenceStrategy from '@alme/ui-web/ref/persistence-strategy-cookie';
import StepOutIcon from '@alme/ui-web/ref/renderer-step-out-icon';
import WelcomeUserAppevent from '@alme/ui-web/ref/appevent-welcomeuser-onlaunch';
import getHistoryWatcher from '@alme/ui-web/ref/history-watcher';
import InitializeGetHistory from '@alme/ui-web/ref/initialization-gethistory';
import InitializeGetConfiguration from '@alme/ui-web/ref/initialization-get-configuration';
import InputboxLockMutator from '@alme/ui-web/ref/inputbox-lock-mutator';
import InputBoxAutoFocus from '@alme/ui-web/ref/inputbox-autofocus';
import { setupAlmeWindow } from './setup-window-components';
import { setupConversation } from './setup-conversation-components';
import SingleLinkRenderer from '@alme/ui-web/ref/single-link-renderer';
import StateTriggerer from "@alme/ui-web/modules/state-triggerer/src/StateTriggerer";
import ElementDisabler from '@alme/ui-web/ref/element-disabler';
import { settings } from '@alme/ui-web/settings/settings-util';
//custom
import KeyframeDispatcher from '@nextit/nextit-keyframe-dispatcher';
import Animator from '@nextit/nextit-animator-raf';
import InlineSurveyLinks from '@nextit/nextit-response-handler-inline-survey-links/src/nextit-inline-survey-links';
import TTSResponseHandler from '@alme/ui-web/ref/response-handler-tts';
import IvaAvailability from '@alme/ui-web/ref/iva-availability';
import LiveChat from '@alme/ui-web/ref/livechat-foundation';


function setupComponents(conversation, onContactUsPage){
    const components = {};

    //initialization steps
    components.persistenceStrategy = new PersistenceStrategy();
    components.initializeGetHistory = new InitializeGetHistory();
    components.initializeGetConfiguration = new InitializeGetConfiguration();
    components.welcomeUserAppevent = new WelcomeUserAppevent();
    components.liveChatFoundation = new LiveChat();
    const initializationSteps = {
            onLoad: [
                components.persistenceStrategy,
            ],
            onLaunch: [
                
                components.initializeGetHistory,
                components.initializeGetConfiguration,
                components.welcomeUserAppevent,
                components.liveChatFoundation.Poller,

            ],
        };

    //other components
    components.autoNavUrl = new AutoNavUrl();
    components.clientCommunicator = new ClientCommunicator();
    components.historyAppender = new HistoryAppender();
    const initialization = new Initialization(initializationSteps);
    components.launchMessageProcessor = new LaunchMessageProcessor();
    components.mobileDeviceDetector = new MobileDeviceDetector();
    components.persistentStorage = new PersistentStorage();
    components.historyWatcher = getHistoryWatcher();
    components.stepOutIcon = new StepOutIcon();
    components.inputboxLockMutator = new InputboxLockMutator();
    components.inputBoxAutoFocus = new InputBoxAutoFocus();
    components.stateTriggerer = new StateTriggerer();
    components.singleLinkRenderer = new SingleLinkRenderer(settings, getHistoryWatcher);
    components.elementDisabler = new ElementDisabler();

    //  custom
     components.animator = new Animator(settings);
     components.keyframer = new KeyframeDispatcher(settings, components.animator);
     components.ttsResponseHandler = new TTSResponseHandler(settings);
     components.inlineSurveyLinks = new InlineSurveyLinks(settings, components.singleLinkRenderer);

     components.ivaAvailability = new IvaAvailability(settings);

    //used for mocking
     window.IvaAvailability = components.ivaAvailability;

    Object.assign(components, setupAlmeWindow(components, onContactUsPage),
        setupConversation(components, conversation));

    return {
        components,
        initialization,
    };
}

export {
    setupComponents
};



// WEBPACK FOOTER //
// ./src/setup-components.js